import { NewSessionInvitationData } from './NewSessionInvitationDialogController'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { useTranslation } from 'react-i18next'
import { DialogBody, DialogTitle } from '@/components/Dialog'
import EnvelopeIcon from '@/CustomIcons/EnvelopeIcon'

export default function NewSessionInvitationDialogContents({
    dialogData,
    onAcceptInvitation,
    onDefaultClose,
}: {
    dialogData: NewSessionInvitationData
    onAcceptInvitation: () => void
    onDefaultClose: () => void
}) {
    const { t } = useTranslation()

    return (
        <div className="w-full">
            <DialogBody>
                <div className="flex items-center gap-2 mb-4">
                    <EnvelopeIcon />
                    <DialogTitle noPadding>{t('Session Invitation')}</DialogTitle>
                </div>

                <div className="mb-3">
                    {t('{{username}} invited you to join a session.', { username: dialogData.username })}
                </div>

                <div className="px-5 py-4 bg-white/5 rounded-2xl shadow-glow border-muse-toplit-low mb-3">
                    <div className="flex flex-col gap-1">
                        {dialogData.roomName ? (
                            <div>
                                {t('Session name:')} <span style={{ color: '#f9cc04' }}>{dialogData.roomName}</span>
                            </div>
                        ) : (
                            <div>
                                {t('Session name:')}{' '}
                                <span style={{ color: '#f9cc04' }}>{dialogData.username}'s Session</span>
                            </div>
                        )}

                        <div>
                            {t('Session code:')} <span style={{ color: '#f9cc04' }}>{dialogData.roomJoinCode}</span>
                        </div>
                    </div>
                </div>
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText="Deny"
                rightButtonText="Accept"
                onLeftButtonClicked={onDefaultClose}
                onRightButtonClicked={onAcceptInvitation}
            />
        </div>
    )
}
